<template>
  <div class="product-run-page-content">
    <el-form
      :inline="screenWidth >= 768"
      :model="form"
      :rules="formRules"
      ref="form"
      label-width="60px"
    >
      <el-form-item :label="$t('text.tester')" prop="testerName">
        <el-input
          v-model="form.testerName"
          size="small"
          class="w-175"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.product')" prop="product">
        <el-select
          v-model="form.productId"
          :placeholder="$t('text.please_select')"
          size="small"
          filterable
          class="filter-selelct"
        >
          <el-option
            v-for="item in products"
            :key="item.id"
            :label="item.productName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.pod')" prop="pod">
        <el-select
          v-model="form.pod"
          :placeholder="$t('text.please_select')"
          size="small"
          filterable
          class="filter-selelct"
        >
          <el-option
            v-for="item in podsOptions"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.position')" prop="position">
        <el-select
          v-model="form.position"
          size="small"
          :placeholder="$t('text.please_select')"
        >
          <el-option
            v-for="item in positionOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.weight')" prop="comments">
        <el-input v-model="form.comments" size="small" class="w-175">
          <template slot="append"
            >kg</template
          >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="text-right mb-20 mt-30 mr-30 btn-wrapper">
      <span class="mr-10 red-font" v-if="incompleteRunRecord"
        >{{ $t('text.incomplete_run') }}:
        {{
          userLang.indexOf('en') > -1
            ? moment
                .utc(incompleteRunRecord.charData.startedTime)
                .tz(utcOffset)
                .format('DD MMM YY')
            : moment
                .utc(incompleteRunRecord.charData.startedTime)
                .tz(utcOffset)
                .format('DD/MM/YY')
        }}
        @
        {{
          moment
            .utc(incompleteRunRecord.charData.startedTime)
            .tz(utcOffset)
            .format('h:mm a')
        }}</span
      >
      <b-button
        variant="outline-primary"
        class="min-w-100"
        @click="goContinue()"
        v-if="incompleteRunRecord"
        >{{ $t('text.continue').toUpperCase() }}</b-button
      >
    </div>
    <div class="text-right mr-30 btn-wrapper">
      <b-button
        variant="outline-success"
        class="min-w-100"
        @click="goStart()"
        >{{ $t('text.start_new').toUpperCase() }}</b-button
      >
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      moment,
      userLang: navigator.language || navigator.userLanguage,
      screenWidth: window.innerWidth,
      form: {
        testerName: '',
        productId: '',
        pod: '',
        position: '',
        comments: ''
      },
      formRules: this.initFormRules(),
      products: [],
      podsOptions: [],
      positionOptions: this.initPositionOptions(),
      incompleteRunRecord: ''
    }
  },
  props: {
    utcOffset: {
      type: String,
      required: true
    }
  },
  mounted() {
    // Fixed a problem with the filterable select box, which cannot pop up on the soft keyboard on IOS
    Array.from(document.getElementsByClassName('filter-selelct')).forEach(
      item => {
        item.children[0].children[0].removeAttribute('readOnly')
        item.children[0].children[0].onblur = function() {
          let _this = this
          setTimeout(() => {
            _this.removeAttribute('readOnly')
          }, 200)
        }
      }
    )

    window.addEventListener('resize', this.getScreenWidth)
    this.loadAllProducts()
    this.loadAllPods()
    //block out old data
    let storedRecord = JSON.parse(localStorage.getItem('incomplete_run'))
    if (storedRecord && !storedRecord.charData.startedTime) {
      localStorage.removeItem('incomplete_run')
    }
    this.incompleteRunRecord = JSON.parse(
      localStorage.getItem('incomplete_run')
    )
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.positionOptions = this.initPositionOptions()
      // this.formRules = this.initFormRules()
    }
  },
  methods: {
    initFormRules() {
      return {
        testerName: [
          {
            required: true,
            message: this.$t('text.tester_required'),
            trigger: 'blur'
          }
        ],
        productId: [
          {
            required: true,
            message: this.$t('text.product_required'),
            trigger: 'change'
          }
        ],
        pod: [
          {
            required: true,
            message: this.$t('text.pod_required'),
            trigger: 'change'
          }
        ],
        position: [
          {
            required: true,
            message: this.$t('text.position_required'),
            trigger: 'change'
          }
        ],
        comments: [
          {
            required: true,
            message: this.$t('text.weight_required'),
            trigger: 'blur'
          }
        ]
      }
    },
    initPositionOptions() {
      return [
        {
          label: this.$t('text.lying_left'),
          value: 'Lying Left'
        },
        {
          label: this.$t('text.lying_right'),
          value: 'Lying Right'
        },
        {
          label: this.$t('text.lying_back'),
          value: 'Lying Back'
        },
        {
          label: this.$t('text.lying_front'),
          value: 'Lying Front'
        },
        {
          label: this.$t('text.sit'),
          value: 'Sit'
        },
        {
          label: this.$t('text.stand'),
          value: 'Stand'
        }
      ]
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    goContinue() {
      this.$parent.$refs.runContinue.isContinue = true
      this.$parent.$refs.runContinue.charData = this.incompleteRunRecord.charData
      this.$parent.$refs.runContinue.volData = this.incompleteRunRecord.volData
      this.$parent.$refs.runContinue.commentData = this.incompleteRunRecord.commentData
      this.toContinuePage()
    },
    goStart() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$parent.$refs.runContinue.charData = {
            ...this.form,
            startedTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            productName: this.getProductName(this.form.productId)
          }
          this.toContinuePage()
        }
      })
    },
    getProductName(productId) {
      let productName = ''
      this.products.forEach(product => {
        if (product.id === productId) {
          productName = product.productName
        }
      })
      return productName
    },
    toContinuePage() {
      this.$refs.form.resetFields()
      this.$parent.haveInit = true
      this.$nextTick(() => {
        this.$parent.$refs.runContinue.isFinished = false
        this.$parent.$refs.runContinue.initChart()
        this.$parent.$refs.runContinue.chartTimer = setInterval(
          this.$parent.$refs.runContinue.getPodData,
          3000
        )
      })
    },
    loadAllProducts() {
      const user = JSON.parse(localStorage.getItem('user'))
      ApiService.GetProductsById(user.id).then(response => {
        this.products = response.data.data
      })
    },
    loadAllPods() {
      ApiService.GetConfiguration().then(response => {
        this.podsOptions = response.data.pods.map(item => {
          return {
            value: item.podId
          }
        })
      })
    }
  }
}
</script>
